module.exports = __webpack_public_path__ + "img/apt-1.0233ee25.jpg";